import { Button } from "antd"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import classNames from "classnames"

const IconWithBg = ({ icon, onClick, className, ...props }) => {
  return <Button shape="circle" icon={icon} className={classNames(styles.iconWithBg, className)} onClick={onClick} {...props} />
}

IconWithBg.propTypes = {
  icon: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string
}

export default IconWithBg
